import React from 'react';
import {FaFile} from "react-icons/fa";
import InfoGrid from "../../../../../../components/info-grid/info-grid.jsx";

const OccurrenceAttaches = ({data}) => {
    const attaches = data.attachs ?? []
    if (!attaches.length || !attaches) return null;

    return (
        <>
            { attaches && (
                <section className="space-y-4! px-5!">
                    <h2 className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f] print:text-[19px]! print:break-after-avoid! mb-2">
                        ANEXOS
                    </h2>

                    { attaches.map((item, index) => {

                        const info = [
                            {
                                label: null,
                                children: (item?.description || item?.name) ? (
                                    <>
                                        <div className="flex flex-row items-center gap-2 text-[14px] print:text-[17px]">
                                            <span className={'text-[13px]! text-[#4f4f4f]!'}>Anexo: </span>
                                            <FaFile className={'shrink-0!'}/> <span className={'break-all! max-w-[940px]! print:max-w-[1200px]!'}>{item?.description ?? item?.name}</span>
                                        </div>
                                    </>
                                ) : null,
                                span: 3
                            }
                        ];

                        return (
                            <>
                                <InfoGrid key={`${index}`} title={""} items={info} columns={3} labelClassName="text-[#4F4F4F] text-[13px]! print:text-[15px]!" valueClassName={'print:text-[17px]!'} className={'pb-3 px-0!'} contentClassName={'space-y-1'}/>
                            </>
                        )

                    })}
                </section>
            )}
        </>
    );
};

export default OccurrenceAttaches;